/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BusinessTypeMonthlyStat } from './BusinessTypeMonthlyStat';
import {
    BusinessTypeMonthlyStatFromJSON,
    BusinessTypeMonthlyStatFromJSONTyped,
    BusinessTypeMonthlyStatToJSON,
    BusinessTypeMonthlyStatToJSONTyped,
} from './BusinessTypeMonthlyStat';

/**
 * 
 * @export
 * @interface MonthlyBusinessStructure
 */
export interface MonthlyBusinessStructure {
    /**
     * 月份（1-12）
     * @type {number}
     * @memberof MonthlyBusinessStructure
     */
    month?: number;
    /**
     * 各业务类型统计
     * @type {Array<BusinessTypeMonthlyStat>}
     * @memberof MonthlyBusinessStructure
     */
    types?: Array<BusinessTypeMonthlyStat>;
}

/**
 * Check if a given object implements the MonthlyBusinessStructure interface.
 */
export function instanceOfMonthlyBusinessStructure(value: object): value is MonthlyBusinessStructure {
    return true;
}

export function MonthlyBusinessStructureFromJSON(json: any): MonthlyBusinessStructure {
    return MonthlyBusinessStructureFromJSONTyped(json, false);
}

export function MonthlyBusinessStructureFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonthlyBusinessStructure {
    if (json == null) {
        return json;
    }
    return {
        
        'month': json['month'] == null ? undefined : json['month'],
        'types': json['types'] == null ? undefined : ((json['types'] as Array<any>).map(BusinessTypeMonthlyStatFromJSON)),
    };
}

export function MonthlyBusinessStructureToJSON(json: any): MonthlyBusinessStructure {
    return MonthlyBusinessStructureToJSONTyped(json, false);
}

export function MonthlyBusinessStructureToJSONTyped(value?: MonthlyBusinessStructure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'month': value['month'],
        'types': value['types'] == null ? undefined : ((value['types'] as Array<any>).map(BusinessTypeMonthlyStatToJSON)),
    };
}

